import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FundOutlinedSvg from "@ant-design/icons-svg/es/asn/FundOutlined";
import AntdIcon from '../components/AntdIcon';
var FundOutlined = function FundOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: FundOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(FundOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'FundOutlined';
}
export default RefIcon;